module.exports = __webpack_public_path__ + "static/img/mercedes-screen3cut-1x.865c4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mercedes-screen3cut-1x.png
// module id = oEkw
// module chunks = 0